import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { spacing16 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  componentId: "sc-zwfeft-0"
})(["display:flex;width:100%;justify-content:space-between;align-items:center;padding:", ";"], spacing16);
const Head = _ref => {
  let {
    start,
    end
  } = _ref;
  return /*#__PURE__*/_jsxs(Container, {
    children: [start ? start : /*#__PURE__*/_jsx("div", {}), end ? end : /*#__PURE__*/_jsx("div", {})]
  });
};
Head.propTypes = {
  /** First section of header */
  start: PropTypes.node,
  /** second section of header */
  end: PropTypes.node
};
export default Head;